import React from "react";

// "87/100" under a text input once its value nears the limit; red when the limit is reached,
// so a cut-off paste is visible. Inline styles: module-only Tailwind classes are not in the host build.
interface FieldCounterProps {
  value?: string | number | null;
  max?: number;
}

const FieldCounter = ({ value, max }: FieldCounterProps) => {
  if (!max) return null;
  // UTF-16 units, as the input's maxLength counts them (an emoji is 2).
  const length = String(value ?? "").length;
  if (length < Math.floor(max * 0.8)) return null;
  const full = length >= max;
  return (
    <div
      aria-live="polite"
      style={{ fontSize: 12, lineHeight: "16px", marginTop: 4, textAlign: "right", color: full ? "#E40F03" : "#6B7280" }}
    >
      {length}/{max}
    </div>
  );
};

export default FieldCounter;
